<template lang="pug">
.d-contents
  template(v-if="!isMergeEmailCodeSended")
    p Для объединения ваших учетных записей укажите email {{ duplicate.other_user.profile.email }}&nbsp;
      | от второго (не текущего) аккаунта. На него будет отправлен код, после ввода которого&nbsp;
      | и произойдет объединение.
  api-form(
    :fields="mergeEmailFormFields"
    :initial="mergeEmailFormFieldsInitial"
    :method="isMergeEmailCodeSended ? resendMergeEmailCode : sendMergeEmailCode"
    no-reset
  ).d-flex.gap-16
    template(#save-btn="{ attrs, invalid, loading }")
      div
        app-button(
          v-bind="attrs"
          :loading="loading"
          :disabled="invalid || !!timerValue"
          rounded
        )
          span {{ isMergeEmailCodeSended ? 'Отправить код повторно' : 'Получить код' }}
          span(v-if="timerValue") : {{ timerValue }}
  template(v-if="isMergeEmailCodeSended")
    p Введите код, полученный из письма, отправленного на email {{ duplicate.other_user.profile.email }}&nbsp;
    api-form(
      :fields="mergeEmailCodeFormFields"
      :method="onInitClick"
    ).d-flex.gap-16
      template(#save-btn="{ attrs, invalid, loading }")
        div
          app-button(
            v-bind="attrs"
            :loading="loading"
            :disabled="invalid"
            rounded
          ) Объединить аккаунты
</template>

<script>
import ApiForm from '@/components/global/ApiForm.vue';
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import { USER_DUPLICATE_STATUS_KEY } from './constants';

export default {
  name: 'MergeEmail',
  components: {
    ApiForm,
    AppButton,
  },
  props: {
    duplicate: {
      type: Object,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { status, user_duplicate_merges, other_user } = this.duplicate;
    const isCodeWasSent = status.id === USER_DUPLICATE_STATUS_KEY.mergeInitiate && user_duplicate_merges.length > 1;
    const lastDuplicate = user_duplicate_merges.find(({ owner_id }) => owner_id === this.$user?.id) || user_duplicate_merges[user_duplicate_merges.length - 1];

    const email = lastDuplicate?.email || this.$user?.profile?.email || other_user?.profile?.email || '';

    return {
      isMergeEmailCodeSended: isCodeWasSent,
      mergeEmailFormFields: [
        {
          text: 'Email',
          value: 'email',
          rules: 'required|email',
          component: 'app-text-input',
          component_attrs: {
            placeholder: 'Введите email от вашего другого аккаунта',
          },
        },
      ],
      mergeEmailFormFieldsInitial: {
        email,
      },
      mergeEmailCodeFormFields: [
        {
          text: 'Код из письма',
          value: 'code',
          rules: 'required',
          component: 'app-text-input',
          component_attrs: {
            placeholder: 'Введите код из письма',
          },
        },
      ],

      activeResendTimer: null,
      timerValue: 0,
    };
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {
    this.finishTimer();
  },
  methods: {
    async sendMergeEmailCode({ data }) {
      const args = [this.duplicate.id];

      const { error } = await this.$rApi.userDuplicates.initiateEmail({ args, data });
      if (error) {
        return;
      }

      this.$toast.success('Код отправлен на Email');
      this.isMergeEmailCodeSended = true;
      this.startTimer();
    },
    async resendMergeEmailCode({ data }) {
      const args = [this.duplicate.id];

      const { error } = await this.$rApi.userDuplicates.resendEmailCode({ args, data });
      if (error) {
        this.isMergeEmailCodeSended = false;
        return;
      }

      this.$toast.success('Код отправлен на Email');
      this.startTimer();
    },
    startTimer() {
      this.finishTimer();
      this.timerValue = 60;
      this.activeResendTimer = setInterval(() => {
        this.timerValue -= 1;
        if (this.timerValue < 1) {
          this.finishTimer();
        }
      }, 1000);
    },
    finishTimer() {
      if (this.activeResendTimer) clearInterval(this.activeResendTimer);
    },
    onInitClick(data) {
      this.$emit('click:init', data);
    },
  },
};
</script>
